var _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g3, _path13, _path14, _g4, _path15, _path16, _g5, _path17, _path18, _g6, _path19, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovernancesExpertise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13506_34424)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0417 35.85C15.5885 35.85 16.0305 35.4059 16.0305 34.8591C16.0305 34.3122 15.5885 33.8682 15.0417 33.8682C14.4948 33.8682 14.0508 34.3122 14.0508 34.8591C14.0508 35.4059 14.4948 35.85 15.0417 35.85Z",
    fill: "#06513D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13506_34424",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 35,
    width: 5,
    height: 4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 35.6172H17.4076V38.7749H13V35.6172Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13506_34424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1431 36.0654C15.8512 36.3306 15.4647 36.493 15.0412 36.493C14.6177 36.493 14.2333 36.3327 13.9434 36.0716C13.3883 36.3224 13.0039 36.8795 13.0039 37.5292V38.6886H17.0908V37.5292C17.0908 36.8754 16.7023 36.3162 16.1411 36.0654H16.1431Z",
    fill: "#06513D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0266 34.8591C24.0266 34.3122 23.5846 33.8682 23.0378 33.8682C22.4909 33.8682 22.0469 34.3122 22.0469 34.8591C22.0469 35.4059 22.4909 35.85 23.0378 35.85C23.5846 35.85 24.0266 35.4059 24.0266 34.8591Z",
    fill: "#06513D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1353 36.0645C23.8434 36.3297 23.4569 36.4921 23.0334 36.4921C22.6099 36.4921 22.2255 36.3317 21.9356 36.0706C21.3826 36.3214 20.9961 36.8786 20.9961 37.5282V38.6877H25.083V37.5282C25.083 36.8744 24.6945 36.3153 24.1353 36.0645Z",
    fill: "#06513D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0266 29.1188C24.0266 28.572 23.5846 28.1279 23.0378 28.1279C22.4909 28.1279 22.0469 28.572 22.0469 29.1188C22.0469 29.6657 22.4909 30.1077 23.0378 30.1077C23.5846 30.1077 24.0266 29.6657 24.0266 29.1188Z",
    fill: "#06513D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1353 30.3252C23.8434 30.5904 23.4569 30.7528 23.0334 30.7528C22.6099 30.7528 22.2255 30.5924 21.9356 30.3293C21.3826 30.5822 20.9961 31.1393 20.9961 31.7889V32.9463H25.083V31.7889C25.083 31.1352 24.6945 30.576 24.1353 30.3252Z",
    fill: "#06513D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0209 34.8591C32.0209 34.3122 31.5768 33.8682 31.03 33.8682C30.4831 33.8682 30.0391 34.3122 30.0391 34.8591C30.0391 35.4059 30.4831 35.85 31.03 35.85C31.5768 35.85 32.0209 35.4059 32.0209 34.8591Z",
    fill: "#06513D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1332 36.0645C31.8434 36.3297 31.4569 36.4921 31.0313 36.4921C30.6099 36.4921 30.2255 36.3317 29.9335 36.0706C29.3805 36.3214 28.9961 36.8786 28.9961 37.5282V38.6877H33.083V37.5282C33.083 36.8744 32.6924 36.3153 32.1332 36.0645Z",
    fill: "#06513D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0209 29.1188C32.0209 28.572 31.5768 28.1279 31.03 28.1279C30.4831 28.1279 30.0391 28.572 30.0391 29.1188C30.0391 29.6657 30.4831 30.1077 31.03 30.1077C31.5768 30.1077 32.0209 29.6657 32.0209 29.1188Z",
    fill: "#06513D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1332 30.3252C31.8434 30.5904 31.4569 30.7528 31.0313 30.7528C30.6099 30.7528 30.2255 30.5924 29.9335 30.3293C29.3805 30.5822 28.9961 31.1393 28.9961 31.7889V32.9463H33.083V31.7889C33.083 31.1352 32.6924 30.576 32.1332 30.3252Z",
    fill: "#06513D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0209 23.3786C32.0209 22.8317 31.5768 22.3877 31.03 22.3877C30.4831 22.3877 30.0391 22.8317 30.0391 23.3786C30.0391 23.9254 30.4831 24.3674 31.03 24.3674C31.5768 24.3674 32.0209 23.9254 32.0209 23.3786Z",
    fill: "#06513D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1332 24.5869C31.8434 24.8521 31.4569 25.0145 31.0313 25.0145C30.6099 25.0145 30.2255 24.8542 29.9335 24.591C29.3805 24.8439 28.9961 25.401 28.9961 26.0486V27.2081H33.083V26.0486C33.083 25.3969 32.6924 24.8377 32.1332 24.5869Z",
    fill: "#06513D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0149 34.8591C40.0149 34.3122 39.5708 33.8682 39.024 33.8682C38.4772 33.8682 38.0352 34.3122 38.0352 34.8591C38.0352 35.4059 38.4772 35.85 39.024 35.85C39.5708 35.85 40.0149 35.4059 40.0149 34.8591Z",
    fill: "#06513D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13506_34424",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 35,
    width: 6,
    height: 4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8828 35.6162H41.0026V38.7739H36.8828V35.6162Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13506_34424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1332 36.0654C39.8434 36.3306 39.4569 36.493 39.0313 36.493C38.6099 36.493 38.2255 36.3327 37.9356 36.0716C37.3805 36.3224 36.9961 36.8795 36.9961 37.5292V38.6886H41.083V37.5292C41.083 36.8754 40.6924 36.3162 40.1332 36.0654Z",
    fill: "#06513D"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0149 29.1188C40.0149 28.572 39.5708 28.1279 39.024 28.1279C38.4772 28.1279 38.0352 28.572 38.0352 29.1188C38.0352 29.6657 38.4772 30.1077 39.024 30.1077C39.5708 30.1077 40.0149 29.6657 40.0149 29.1188Z",
    fill: "#06513D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13506_34424",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 29,
    width: 6,
    height: 4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8828 29.8291H41.0026V32.9868H36.8828V29.8291Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13506_34424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1332 30.3252C39.8434 30.5904 39.4569 30.7528 39.0313 30.7528C38.6099 30.7528 38.2255 30.5924 37.9356 30.3293C37.3805 30.5822 36.9961 31.1393 36.9961 31.7889V32.9463H41.083V31.7889C41.083 31.1352 40.6924 30.576 40.1332 30.3252Z",
    fill: "#06513D"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0149 23.3786C40.0149 22.8317 39.5708 22.3877 39.024 22.3877C38.4772 22.3877 38.0352 22.8317 38.0352 23.3786C38.0352 23.9254 38.4772 24.3674 39.024 24.3674C39.5708 24.3674 40.0149 23.9254 40.0149 23.3786Z",
    fill: "#06513D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13506_34424",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 24,
    width: 6,
    height: 4
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8828 24.5664H41.0026V27.7241H36.8828V24.5664Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13506_34424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1332 24.585C39.8434 24.8502 39.4569 25.0126 39.0313 25.0126C38.6099 25.0126 38.2255 24.8522 37.9356 24.5891C37.3805 24.8419 36.9961 25.3991 36.9961 26.0466V27.2061H41.083V26.0466C41.083 25.3949 40.6924 24.8358 40.1332 24.585Z",
    fill: "#06513D"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.024 18.6282C39.5708 18.6282 40.0149 18.1862 40.0149 17.6393C40.0149 17.0925 39.5708 16.6484 39.024 16.6484C38.4772 16.6484 38.0352 17.0925 38.0352 17.6393C38.0352 18.1862 38.4772 18.6282 39.024 18.6282Z",
    fill: "#06513D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_13506_34424",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 18,
    width: 6,
    height: 4
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8828 18.7734H41.0026V21.9311H36.8828V18.7734Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_13506_34424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1332 18.8457C39.8434 19.1109 39.4569 19.2733 39.0313 19.2733C38.6099 19.2733 38.2255 19.113 37.9356 18.8498C37.3805 19.1027 36.9961 19.6598 36.9961 20.3074V21.4668H41.083V20.3074C41.083 19.6557 40.6924 19.0965 40.1332 18.8457Z",
    fill: "#06513D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_13506_34424",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 10,
    width: 25,
    height: 20
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10H38.4591V29.3019H14.25V10Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_13506_34424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4667 11.1698L34.3806 12.0496C31.6731 14.311 14.5072 28.6441 14.5072 28.6441C14.4147 28.7222 14.3982 28.8599 14.4722 28.9586C14.5483 29.0593 14.6922 29.0778 14.7929 29.0018C14.7991 28.9935 30.5116 17.0349 35.5319 13.2112L36.2658 15.4068L38.0358 10L32.4667 11.1698Z",
    fill: "#06513D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13506_34424",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13506_34424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13506_34424",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernancesExpertise);
export default __webpack_public_path__ + "static/media/governances-expertise.52f9fa5bea3cc8dc5465be4489325444.svg";
export { ForwardRef as ReactComponent };